import DialogBase      from './DialogBase';
import ErrorDialogBase from './ErrorDialogBase';



export default {
  components: {
    DialogBase,
    ErrorDialogBase,
  },



  data() {
    return {
    }
  },



  computed: {
    $dialog() { return this.$refs.base.$refs.dialog },
  },



  methods: {
    show() { return this.$dialog.show() },
    hide() { return this.$dialog.hide() },
    toggle() { return this.$dialog.toggle() },
  },
}


// WEBPACK FOOTER //
// ./src/js/manager/DbManager/dialogs/dialogMixin.js